import styled from 'styled-components';
import {
  SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DEFAULT_DARK,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
} from '@oneaudi/unified-web-common';

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: ${SEM_COLOR_ACTION_TERTIARY_FOREGROUND_TEXT_DEFAULT_DARK};
  min-height: 37px;
  z-index: 0;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    min-height: 64px;
  }
`;

export const BackToResultsCTA = styled.button`
  display: flex;
  color: black;
  font-family: 'Audi Type';
  font-size: 13px;
  font-weight: 700;
  line-height: 15.23px;
  z-index: 0;
  cursor: pointer;
  background: transparent;
  border: none;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const VehicleDetailsPageWrapper = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;
  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    width: calc(100% - 56px);
    margin: 0 auto;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: calc(100% - 120px);
    margin: 0 auto;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    width: calc(100% - 192px);
    margin: 0 auto;
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    max-width: 1248px;
    margin: 0 auto;
  }
`;
